
<div fxLayout="row" fxLayoutAlign="center center" style="height: 100%;">
    <div class="login mat-elevation-z12">
        <div class="login-header" fxLayout="column" fxLayoutAlign="center center">
            <img class="compass-logo" src="../../../../assets/img/logo-dark.png">
            
        </div>
        <form #form="ngForm" (ngSubmit)="login()">
            <div class="login-content" fxLayout="column" fxLayoutAlign="start stretch">
               <p class="note">{{errMsg}}</p>
                <mat-form-field>
                    <input matInput placeholder="Username" name="mobile" required [(ngModel)]="user" >
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Password" type="password" name="password" required
                           [(ngModel)]="password">
                </mat-form-field>
                <button color="primary" mat-raised-button class="login-button" [disabled]="!form.valid">SIGN IN</button>

            </div>
        </form>
    </div>
</div>

<div class="powered_by">
    <img src="assets/img/powered_by_agnext.png">
</div>





<!-- <div fxLayout="row" fxLayoutAlign="center center" style="height: 100%;">
    <div class="login mat-elevation-z12">
        <div class="login-header" fxLayout="column" fxLayoutAlign="center center">
            <img class="compass-logo" src="../../../../assets/img/agnext_logo.png">
        </div>
        <form #form="ngForm" (ngSubmit)="login()">
            <p class="note">{{errMsg}}</p>
            <div class="login-content" fxLayout="column" fxLayoutAlign="start stretch">

                <mat-form-field>
                    <input matInput placeholder="Username" name="mobile" required value="id"  (keypress)="keyPresss($event)"  [(ngModel)]="user" >
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Password" type="password" autocomplete = "new-password" name="password" required
                           [(ngModel)]="password">
                </mat-form-field>
                <button  class ="login-button" color="primary" mat-raised-button [disabled]="!form.valid">SIGN IN</button>

            </div>
        </form>
    </div>
</div>

<div class="powered_by">
    <img src="assets/img/powered_by_agnext.png">
</div> -->








<!-- <div class="authLayout">
  <table class="resetTable">
    <tr>
      <td class="leftBlock">
        <div class="authLogo">
          <img src="../../../../assets/img/logo-light.png" alt="SenseNext">
        </div>
      </td>
      <td class="rightBlock">
        <div class="authContent">
          <div class="floatContainer">

            <h1 class="yellowUnderLine centerLine">Login</h1>

            <p class="note">{{errMsg}}</p>
            <form #form="ngForm" (ngSubmit)="login()">
              <ul class="fieldList">
                <li>
                  <mat-form-field>
                    <input matInput placeholder="Email ID" type="text" name="mobile" required class="fields"
                      (keypress)="keyPresss($event)" [(ngModel)]="user" />
                  </mat-form-field>
                </li>
                <li>
                  <div class="fieldWrapper">
                    <mat-form-field class="buttonHolder">
                      <input matInput placeholder="Password" [type]="showPassword ? 'text' : 'password'" class="fields"
                        name="password" autocomplete="new-password" name="password" required [(ngModel)]="password" />
                    </mat-form-field>
                    <i class="fieldBtn fa fa-eye-slash" (click)="togglePasswordVisibility(true)"
                      *ngIf="!showPassword"></i>
                    <i class="fieldBtn fa fa-eye" (click)="togglePasswordVisibility(false)" *ngIf="showPassword"></i>
                  </div>
                </li>
                <li>
                  <button class="button-default button-block" type="submit">Sign In</button>
                </li>
              </ul>
            </form>

          </div>
        </div>
      </td>
    </tr>
  </table>
</div> -->